import { PaginationBody } from '@Entities/pagination'
import { RegistrationStatus } from '@App/enum/registration-status'
import { applyMultiSort, paginationPath2v, portalBase2v, publicBase2v, rightsholderBase2v } from '@App/dicts/pathes'

export class Search {
    searchWorks = (pagination: PaginationBody) => {
        const url = new URL(publicBase2v(`search/works${paginationPath2v(pagination)}`))
        applyMultiSort(url, pagination)
        return url.toString()
    }

    searchWorksRH = (rightsholderId: number, pagination: PaginationBody) => {
        const url = new URL(rightsholderBase2v(rightsholderId, `search/works/catalog${paginationPath2v(pagination)}`))
        if (pagination) {
            applyMultiSort(url, pagination)
        }
        return url.toString()
    }

    getWorkSuggestions = (rightsholderId: number, property: string, searchTerm: string, isMatchingTool?: boolean) =>
        new URL(
            rightsholderBase2v(
                rightsholderId,
                `search/works/catalog/suggestions?property=${property}&searchTerm=${searchTerm}${
                    isMatchingTool ? '&isMatchingTool=true' : ''
                }`
            )
        ).toString()

    getPublisherSuggestions = (rightsholderId: number, property: string, searchTerm: string) =>
        new URL(
            rightsholderBase2v(
                rightsholderId,
                `search/works/catalog/suggestions/publishers?property=${property}&searchTerm=${searchTerm}`
            )
        ).toString()

    getWriterSuggestions = (rightsholderId: number, property: string, searchTerm: string) =>
        new URL(
            rightsholderBase2v(
                rightsholderId,
                `search/works/catalog/suggestions/writers?property=${property}&searchTerm=${searchTerm}`
            )
        ).toString()

    searchOverclaimsRH = (rightsholderId: number, pagination: PaginationBody) => {
        const url = new URL(rightsholderBase2v(rightsholderId, `search/overclaims${paginationPath2v(pagination)}`))
        if (pagination) {
            applyMultiSort(url, pagination)
        }
        return url.toString()
    }

    searchOverclaimsRHSuggestions = (rightsholderId: number, property: string, searchTerm: string) =>
        new URL(
            rightsholderBase2v(
                rightsholderId,
                `search/overclaims/suggestions?property=${property}&searchTerm=${searchTerm}`
            )
        ).toString()

    searchWorksForPublisher = (publisherIpId: number, pagination: PaginationBody) => {
        const url = new URL(publicBase2v(`search/works/publisher/${publisherIpId}${paginationPath2v(pagination)}`))
        if (pagination) {
            applyMultiSort(url, pagination)
        }
        return url.toString()
    }

    searchWorksHistoryRH = (
        rightsholderId: number,
        registrationStatus: RegistrationStatus,
        pagination: PaginationBody,
        sort?: string
    ) => {
        const sortString = sort ? `&sort=${sort},desc&sort=master_transaction_id,desc` : ''
        return rightsholderBase2v(
            rightsholderId,
            `search/registration-history${paginationPath2v(pagination)}&status=${registrationStatus}` + sortString
        )
    }
    searchWriters = (pagination: PaginationBody) =>
        new URL(publicBase2v(`search/writers${paginationPath2v(pagination)}`)).toString()

    searchWritersSuggestions = (property: string, searchTerm: string) =>
        new URL(publicBase2v(`search/writers/suggestions?property=${property}&searchTerm=${searchTerm}`)).toString()

    searchPublishers = (pagination: PaginationBody) =>
        new URL(publicBase2v(`search/publishers${paginationPath2v(pagination)}`)).toString()

    searchPublishersSuggestions = (property: string, searchTerm: string) =>
        new URL(publicBase2v(`search/publishers/suggestions?property=${property}&searchTerm=${searchTerm}`)).toString()

    searchPublishersForRH = (rightsHolderId: number, pagination: PaginationBody) => {
        const url = new URL(rightsholderBase2v(rightsHolderId, `search/publishers${paginationPath2v(pagination)}`))
        if (pagination) {
            applyMultiSort(url, pagination)
        }
        return url.toString()
    }

    searchPublishersForCatalogTransfer = (pagination: PaginationBody) => {
        const url = new URL(portalBase2v(`search/publishers/catalog-transfer${paginationPath2v(pagination)}`))
        applyMultiSort(url, pagination)
        return url.toString()
    }

    searchSuggestions = (property: string, searchTerm: string, notClaimedBy?: string, isOverclaimable?: boolean) => {
        const url = new URL(publicBase2v(`search/works/suggestions?property=${property}&searchTerm=${searchTerm}`))
        if (notClaimedBy) {
            url.searchParams.append('notClaimedBy', notClaimedBy)
        }
        if (isOverclaimable !== undefined) {
            url.searchParams.append('isOverclaimable', isOverclaimable.toString())
        }
        return url.toString()
    }
}
